export default "__VITE_ASSET__d54143bf__"